
















































import { Component, Vue, Prop } from 'nuxt-property-decorator'
import InfoCardV3 from '~/components/consumer_map_v3/InfoCardV3.vue'
import InfoCardListItemV3 from '~/components/consumer_map_v3/InfoCardListItemV3.vue'

@Component({
  components: {
    InfoCardV3,
    InfoCardListItemV3,
  },
})
export default class MapPropertiesList extends Vue {
  @Prop({ default: [] }) homes: Array<any>
  @Prop({ default: [] }) homeSites: Array<any>
  @Prop({ default: '' }) homeTabLabel: string
  @Prop({ default: '' }) homesitesTabLabel: string
}
